// extracted by mini-css-extract-plugin
module.exports = {"main":"Scroller-module--main--2yl3Z","riseup":"Scroller-module--riseup--3S9_k"};